import { getFragmentData } from '@e-socna/data-layer';
import type { ResultOf } from '@graphql-typed-document-node/core';
import type { Id } from '@e-socna/data-layer';

import { DocumentEditorResolvers_QuickAccess_ServicesInfo_Fragment } from '../fragments/quick-access.fragment';
import type { DocumentEditorResolvers_QuickAccess_Mission_Fragment } from '../fragments/quick-access.fragment';

type MissionQuickAccess = ResultOf<
  typeof DocumentEditorResolvers_QuickAccess_Mission_Fragment
>;

type LiveServiceUsagesGroup =
  MissionQuickAccess['servicesInfo']['consolidation']['serviceUsagesGroups'][number];

export type MissionLiveServiceUsagesGroup = LiveServiceUsagesGroup &
  Readonly<{ subMissionId: Id | null }>;

// A collaboration prices the groups of its sub-missions, then its own: any
// other mission has no sub-mission and only gets its own groups.
export const getLiveServiceUsagesGroups = (
  quickAccess: MissionQuickAccess,
): readonly MissionLiveServiceUsagesGroup[] => [
  ...quickAccess.subMissions.flatMap((subMission) =>
    getFragmentData(
      DocumentEditorResolvers_QuickAccess_ServicesInfo_Fragment,
      subMission.servicesInfo,
    ).consolidation.serviceUsagesGroups.map((group) => ({
      ...group,
      subMissionId: subMission._id,
    })),
  ),
  ...quickAccess.servicesInfo.consolidation.serviceUsagesGroups.map(
    (group) => ({ ...group, subMissionId: null }),
  ),
];

export const getSubMissionTitles = (
  quickAccess: MissionQuickAccess,
): ReadonlyMap<Id, string> =>
  new Map(
    quickAccess.subMissions.map((subMission) => [
      subMission._id,
      `${subMission.code} - ${subMission.consolidation.title}`,
    ]),
  );
